import { render } from "./Websites.vue?vue&type=template&id=c4521c9e&scoped=true"
import script from "./Websites.vue?vue&type=script&lang=js"
export * from "./Websites.vue?vue&type=script&lang=js"

import "./Websites.vue?vue&type=style&index=0&id=c4521c9e&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4521c9e"]])

export default __exports__